<template>
  <div>
    <table cellpadding="0" cellspacing="0" style="width: 100%">
      <tr>
        <td
          style="
            border: 2px solid black;
            border-right: 0;
            border-bottom: 0;
            width: 50%;
          "
          class="cmr-content-grid"
          colspan="3"
        >
          <table cellpadding="0" cellspacing="0" width="100%">
            <tr class="cmr-title">
              <td>
                <div class="cmr-title-container">
                  <div class="count-indicator">1</div>
                  <div class="title-description">
                    Отправитель (наименование, адрес, страна)<br />
                    Absender (Name, Anschrift, Land)
                  </div>
                </div>
              </td>
            </tr>
            <tr class="cmr-content">
              <td>
                <b
                  >{{ check_undefined(sender.org_name) }},
                  {{ check_undefined(sender.company_address) }},
                  {{ check_undefined(sender.country) }}</b
                >
              </td>
            </tr>
            <tr class="cmr-title">
              <td>
                <div class="cmr-title-container">
                  <div class="count-indicator">2</div>
                  <div class="title-description">
                    Получатель (наименование, адрес, страна)<br />
                    Empfänger (Name, Anschrift, Land)
                  </div>
                </div>
              </td>
            </tr>
            <tr class="cmr-content">
              <td>
                <b
                  >{{ check_undefined(recipient.org_name) }},
                  {{ check_undefined(recipient.company_address) }},
                  {{ check_undefined(recipient.country) }}</b
                >
              </td>
            </tr>
            <tr class="cmr-title">
              <td>
                <div class="cmr-title-container">
                  <div class="count-indicator">3</div>
                  <div class="title-description">
                    Место разгрузки груза<br />
                    Auslieferungsort des Gutes
                  </div>
                </div>
              </td>
            </tr>
            <tr class="cmr-content">
              <td>
                <strong
                  ><b>{{
                    check_undefined(ContractDeliveryTerms.DeliveryPlace)
                  }}</b></strong
                >
              </td>
            </tr>
            <tr class="cmr-title">
              <td>
                <div class="cmr-title-container">
                  <div class="count-indicator">4</div>
                  <div class="title-description">
                    Место и дата погрузки груза<br />
                    Ort und Tag der Ubernahme des Gutes
                  </div>
                </div>
              </td>
            </tr>
            <tr class="cmr-content">
              <td>
                <div>
                  Место / Ort:
                  <strong
                    ><b
                      >{{ check_undefined(city) }},
                      {{ check_undefined(street_house) }},
                      {{ check_undefined(postal_code) }}</b
                    ></strong
                  >
                </div>
                <div>
                  Страна / Land:
                  <strong
                    ><b>{{ check_undefined(taking_country) }}</b></strong
                  >
                </div>
                <div>
                  Дата / Datum:
                  <strong
                    ><b>{{ check_undefined(TakingCargoDate) }}</b></strong
                  >
                </div>
              </td>
            </tr>
            <tr class="cmr-title">
              <td>
                <div class="cmr-title-container">
                  <div class="count-indicator">5</div>
                  <div class="title-description">
                    Прилагаемые документы<br />
                    Beigefügte Dokumente
                  </div>
                </div>
              </td>
            </tr>
            <tr class="cmr-content">
              <td>
                <template v-for="(doc, i) in CMR_docs">
                  <b :key="i"
                    >{{ doc.document_kind == 1 ? "Invoice" : "Packing list" }}
                    {{ check_undefined(doc.document_number) }} ({{
                      check_undefined(doc.document_date)
                    }}),</b
                  >
                </template>
              </td>
            </tr>
          </table>
        </td>
        <td
          style="border: 2px solid black; width: 50%; vertical-align: top"
          class="cmr-content-grid"
          colspan="4"
        >
          <table cellpadding="0" cellspacing="0" width="100%">
            <tr class="cmr-content">
              <td style="border-bottom: 0">
                <div class="split-two">
                  <div style="line-height: 12px">
                    Международная товарно-транспортная накладная /
                    Internationaler Frachtbrief
                  </div>
                  <div style="font-weight: bold; font-size: 16px">
                    <!-- <div class="logo">CMR</div> -->
                    {{ check_undefined(CMR.cmr_number) }}
                  </div>
                </div>
              </td>
            </tr>
            <tr class="cmr-content">
              <td style="border-top: 0">
                <div class="split-two">
                  <div style="line-height: 12px">
                    Данная перевозка,несмотря ни на какие прочие договоры
                    осуществляется в соответствии с условиями Конвенции о
                    договоре международной дорожной перевозки грузов (КДПГ)
                  </div>
                  <div style="line-height: 12px">
                    Diese Beförderung unterliegt trotzeiner gegenteiligen
                    Abmachung denBeatimmungen des Übereinkommensüber den
                    Beförderungsvertrag iminternat. Straßengüterverkehr (CMR)
                  </div>
                </div>
              </td>
            </tr>
            <tr class="cmr-title">
              <td>
                <div class="cmr-title-container">
                  <div class="count-indicator">16</div>
                  <div class="title-description">
                    Перевозчик (наименование, адрес, страна) / Frachtführer
                    (Name, Anschrift, Land)
                  </div>
                </div>
              </td>
            </tr>
            <tr class="cmr-content">
              <td>
                <b
                  >{{ check_undefined(courier.org_name) }},
                  {{ check_undefined(courier.company_address) }},
                  {{ check_undefined(courier.country) }}</b
                >
              </td>
            </tr>
            <tr class="cmr-title">
              <td>
                <div class="cmr-title-container">
                  <div class="count-indicator">17</div>
                  <div class="title-description">
                    Последующий перевозчик (наименование, адрес, страна) /
                    Nachfolgende Frachtführer (Name, Anschrift, Land)
                  </div>
                </div>
              </td>
            </tr>
            <tr class="cmr-content">
              <td>
                <b
                  >{{ check_undefined(courier_next.org_name) }},
                  {{ check_undefined(courier_next.company_address) }},
                  {{ check_undefined(courier_next.country) }}</b
                >
              </td>
            </tr>
            <tr class="cmr-title">
              <td>
                <div class="cmr-title-container">
                  <div class="count-indicator">18</div>
                  <div class="title-description">
                    Оговорки и замечания перевозчика / Vorbehalte und
                    Bemerkungeh der Frachtführer
                  </div>
                </div>
              </td>
            </tr>
            <tr class="cmr-content">
              <td style="border-bottom: 0">
                <b>{{ check_undefined(cmr_courier_notes) }}</b>
              </td>
            </tr>
          </table>
        </td>
      </tr>
      <tr class="cmr-title">
        <td class="cmr-content-grid-rd" width="14%">
          <div class="cmr-title-container">
            <div class="count-indicator">6</div>
            <div class="title-description">
              Знаки и номера<br />Kennzeichen und Nummern
            </div>
          </div>
        </td>
        <td class="cmr-content-grid-rd" width="14%">
          <div class="cmr-title-container">
            <div class="count-indicator">7</div>
            <div class="title-description">
              Количество мест<br />Anzahl der Packstücke
            </div>
          </div>
        </td>
        <td class="cmr-content-grid-rd" width="14%">
          <div class="cmr-title-container">
            <div class="count-indicator">8</div>
            <div class="title-description">
              Род&nbsp;упаковки<br />Art&nbsp;der&nbsp;Verp.
            </div>
          </div>
        </td>
        <td class="cmr-content-grid-rd" width="14%">
          <div class="cmr-title-container">
            <div class="count-indicator">9</div>
            <div class="title-description">
              Наименование&nbsp;груза<br />Bezeic.&nbsp;des&nbsp;Gutes
            </div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd"
          width="14%"
          style="border-left: 1px solid black"
        >
          <div class="cmr-title-container">
            <div class="count-indicator">10</div>
            <div class="title-description">
              Стат.&nbsp;No<br />Stat.&nbsp;-&nbsp;Nr.
            </div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd"
          width="14%"
          style="border-left: 1px solid black"
        >
          <div class="cmr-title-container">
            <div class="count-indicator">11</div>
            <div class="title-description">
              Вес&nbsp;брт.,&nbsp;кг<br />Brutto.,&nbsp;kg
            </div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd"
          width="14%"
          style="border-left: 1px solid black"
        >
          <div class="cmr-title-container">
            <div class="count-indicator">12</div>
            <div class="title-description">Объем, м3<br />Umfang in m3</div>
          </div>
        </td>
      </tr>
      <tr class="cmr-title" v-for="(good, i) in CMRGoods" :key="i">
        <td class="cmr-content-grid-rd">
          <b>{{ check_undefined(good.GoodMarking) }}</b>
        </td>
        <td class="cmr-content-grid-rd">
          <b>{{ check_undefined(good.GoodsQuantity) }}</b>
        </td>
        <td class="cmr-content-grid-rd">
          <div v-if="good.places.length > 0">
            <span v-for="(place, i) in good.places" :key="i" class="ml-1">
              <template
                v-if="
                  typeof place.PackagingType !== 'undefined' &&
                  typeof place.PackagingType.display_text !== 'undefined'
                "
              >
                {{ place.PackagingType.display_text }}
              </template>
            </span>
          </div>
        </td>
        <td class="cmr-content-grid-rd">
          <b>{{ check_undefined(good.GoodsDescription) }}</b>
        </td>
        <td class="cmr-content-grid-rd" style="border-left: 1px solid black">
          <b>{{ check_undefined(good.GoodsNomenclatureCode) }}</b>
        </td>
        <td class="cmr-content-grid-rd" style="border-left: 1px solid black">
          <b>{{ check_undefined(good.GrossWeightQuantity) }}</b>
        </td>
        <td class="cmr-content-grid-rd" style="border-left: 1px solid black">
          <b>{{ check_undefined(good.VolumeQuantity) }}</b>
        </td>
      </tr>
      <tr class="cmr-title">
        <td class="cmr-content-grid-rd">
          <div class="split-two">
            <div>Класс / Klasse</div>
          </div>
        </td>
        <td class="cmr-content-grid-rd">
          <div class="split-two">
            <div>Цифра / Zifer</div>
          </div>
        </td>
        <td class="cmr-content-grid-rd">
          <div class="split-two">
            <div>Буква / Buchstabe</div>
          </div>
        </td>
        <td class="cmr-content-grid-rd">
          <div class="split-two">
            <div>ДОПОЛ. / ADR</div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd"
          style="border-left: 1px solid black"
        ></td>
        <td class="cmr-content-grid-rd" style="border-left: 1px solid black">
          <b>{{ check_undefined(weight_total) }}</b>
        </td>
        <td class="cmr-content-grid-rd" style="border-left: 1px solid black">
          <b>{{ check_undefined(volume_total) }}</b>
        </td>
      </tr>
      <tr class="cmr-title">
        <td
          class="cmr-content-grid-rd"
          colspan="3"
          style="border-top: 2px solid black"
        >
          <div class="cmr-title-container">
            <div class="count-indicator">13</div>
            <div class="title-description">
              Указания отправителя (таможенная и прочая обработка)<br />Anweisungen
              des Absenders (Zoll-und sonstige amtliche Behandlung)
            </div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd"
          style="border-top: 2px solid black; border-left: 2px solid black"
        >
          <div class="cmr-title-container">
            <div class="count-indicator">19</div>
            <div class="title-description">
              Подл. оплате:<br />Zu zahlen vom:
            </div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd"
          style="border-top: 2px solid black; border-left: 2px solid black"
        >
          <div class="cmr-title-container">
            <div class="title-description">Отправитель<br />Absender</div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd"
          style="border-top: 2px solid black; border-left: 2px solid black"
        >
          <div class="cmr-title-container">
            <div class="title-description">Валюта<br />Währung</div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd"
          style="border-left: 2px solid black; border-top: 2px solid black"
        >
          <div class="cmr-title-container">
            <div class="title-description">Получатель<br />Empfänger</div>
          </div>
        </td>
      </tr>
      <tr class="cmr-title">
        <td
          class="cmr-content-grid-rd"
          colspan="3"
          rowspan="4"
          style="border-top: 2px solid black"
        >
          <div
            class="cmr-title-container"
            v-html="check_undefined(cmr_custom_code)"
          ></div>
        </td>
        <td
          class="cmr-content-grid-rd"
          style="border-top: 2px solid black; border-left: 2px solid black"
        >
          <div class="cmr-title-container">
            <!-- <div class="split-two"> -->
            <div class="title-description">Ставка<br />Fracht</div>
            <div></div>
            <!-- </div> -->
          </div>
        </td>
        <td
          class="cmr-content-grid-rd percents-70-border"
          style="border-top: 2px solid black; border-left: 2px solid black"
        >
          <div class="cmr-title-container">
            <!-- <div class="split-two"> -->
            <div class="flex-70"></div>
            <div class="flex-30"></div>
            <!-- </div> -->
          </div>
        </td>
        <td
          class="cmr-content-grid-rd magic-div-container percents-50-border"
          style="border-top: 2px solid black; border-left: 2px solid black"
        >
          <div class="cmr-title-container">
            <div class="flex-50"></div>
            <div class="flex-50"></div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd percents-70-border"
          style="border-top: 2px solid black; border-left: 2px solid black"
        >
          <div class="cmr-title-container">
            <!-- <div class="split-two"> -->
            <div class="flex-70"></div>
            <div class="flex-30"></div>
            <!-- </div> -->
          </div>
        </td>
      </tr>
      <tr class="cmr-title">
        <td
          class="cmr-content-grid-rd"
          style="border-bottom: 2px solid black; border-left: 2px solid black"
        >
          <div class="cmr-title-container">
            <!-- <div class="split-two"> -->
            <div class="title-description">Скидки<br />Ermäßigungen</div>
            <div style="text-align: right">–</div>
            <!-- </div> -->
          </div>
        </td>
        <td
          class="cmr-content-grid-rd percents-70-border"
          style="border-bottom: 2px solid black; border-left: 2px solid black"
        >
          <div class="cmr-title-container">
            <!-- <div class="split-two"> -->
            <div class="flex-70"></div>
            <div class="flex-30"></div>
            <!-- </div> -->
          </div>
        </td>
        <td
          class="cmr-content-grid-rd magic-div-container percents-50-border"
          style="border-bottom: 2px solid black; border-left: 2px solid black"
        >
          <div class="cmr-title-container">
            <div class="flex-50"></div>
            <div class="flex-50"></div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd percents-70-border"
          style="border-bottom: 2px solid black; border-left: 2px solid black"
        >
          <div class="cmr-title-container">
            <!-- <div class="split-two"> -->
            <div class="flex-70"></div>
            <div class="flex-30"></div>
            <!-- </div> -->
          </div>
        </td>
      </tr>
      <tr class="cmr-title">
        <td class="cmr-content-grid-rd" style="border-left: 2px solid black">
          <div class="cmr-title-container">
            <!-- <div class="split-two"> -->
            <div class="title-description">Разность<br />Zwischensumme</div>
            <div></div>
            <!-- </div> -->
          </div>
        </td>
        <td
          class="cmr-content-grid-rd percents-70-border"
          style="border-left: 2px solid black"
        >
          <div class="cmr-title-container">
            <!-- <div class="split-two"> -->
            <div class="flex-70"></div>
            <div class="flex-30"></div>
            <!-- </div> -->
          </div>
        </td>
        <td
          class="cmr-content-grid-rd magic-div-container percents-50-border"
          style="border-left: 2px solid black"
        >
          <div class="cmr-title-container">
            <div class="flex-50"></div>
            <div class="flex-50"></div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd percents-70-border"
          style="border-left: 2px solid black"
        >
          <div class="cmr-title-container">
            <!-- <div class="split-two"> -->
            <div class="flex-70"></div>
            <div class="flex-30"></div>
            <!-- </div> -->
          </div>
        </td>
      </tr>
      <tr class="cmr-title">
        <td class="cmr-content-grid-rd" style="border-left: 2px solid black">
          <div class="cmr-title-container">
            <!-- <div class="split-two"> -->
            <div class="title-description">Надбавки<br />Zuschlänge</div>
            <div></div>
            <!-- </div> -->
          </div>
        </td>
        <td
          class="cmr-content-grid-rd percents-70-border"
          style="border-left: 2px solid black"
        >
          <div class="cmr-title-container">
            <!-- <div class="split-two"> -->
            <div class="flex-70"></div>
            <div class="flex-30"></div>
            <!-- </div> -->
          </div>
        </td>
        <td
          class="cmr-content-grid-rd magic-div-container percents-50-border"
          style="border-left: 2px solid black"
        >
          <div class="cmr-title-container">
            <div class="flex-50"></div>
            <div class="flex-50"></div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd percents-70-border"
          style="border-left: 2px solid black"
        >
          <div class="cmr-title-container">
            <!-- <div class="split-two"> -->
            <div class="flex-70"></div>
            <div class="flex-30"></div>
            <!-- </div> -->
          </div>
        </td>
      </tr>
      <tr class="cmr-title">
        <td class="cmr-content-grid-rd" colspan="3">
          <div class="title-description">
            Объявленная стоимость груза<br />Adgabe des Wertes des Gutes
          </div>
        </td>
        <td class="cmr-content-grid-rd" style="border-left: 2px solid black">
          <div class="cmr-title-container">
            <!-- <div class="split-two"> -->
            <div class="title-description">
              Дополнительные сборы<br />Nebengebühren
            </div>
            <div></div>
            <!-- </div> -->
          </div>
        </td>
        <td
          class="cmr-content-grid-rd percents-70-border"
          style="border-left: 2px solid black"
        >
          <div class="cmr-title-container">
            <!-- <div class="split-two"> -->
            <div class="flex-70"></div>
            <div class="flex-30"></div>
            <!-- </div> -->
          </div>
        </td>
        <td
          class="cmr-content-grid-rd magic-div-container percents-50-border"
          style="border-left: 2px solid black"
        >
          <div class="cmr-title-container">
            <div class="flex-50"></div>
            <div class="flex-50"></div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd percents-70-border"
          style="border-left: 2px solid black"
        >
          <div class="cmr-title-container">
            <!-- <div class="split-two"> -->
            <div class="flex-70"></div>
            <div class="flex-30"></div>
            <!-- </div> -->
          </div>
        </td>
      </tr>
      <tr class="cmr-title">
        <td class="cmr-content-grid-rd" colspan="3">
          <div class="title-description">
            (при превышении предела ответственности предусмотренного гл. IV, ст.
            23,<br />п. 3 указывается только после согласования дополнительной
            платы к фракту)
          </div>
        </td>
        <td class="cmr-content-grid-rd" style="border-left: 2px solid black">
          <div class="cmr-title-container">
            <!-- <div class="split-two"> -->
            <div class="title-description">Прочие<br />Songstiges</div>
            <div style="text-align: right">+</div>
            <!-- </div> -->
          </div>
        </td>
        <td
          class="cmr-content-grid-rd percents-70-border"
          style="border-left: 2px solid black"
        >
          <div class="cmr-title-container">
            <!-- <div class="split-two"> -->
            <div class="flex-70"></div>
            <div class="flex-30"></div>
            <!-- </div> -->
          </div>
        </td>
        <td
          class="cmr-content-grid-rd magic-div-container percents-50-border"
          style="border-left: 2px solid black"
        >
          <div class="cmr-title-container">
            <div class="flex-50"></div>
            <div class="flex-50"></div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd percents-70-border"
          style="border-left: 2px solid black"
        >
          <div class="cmr-title-container">
            <!-- <div class="split-two"> -->
            <div class="flex-70"></div>
            <div class="flex-30"></div>
            <!-- </div> -->
          </div>
        </td>
      </tr>
      <tr class="cmr-title">
        <td
          class="cmr-content-grid-rd"
          colspan="3"
          style="border-bottom: 2px solid black"
        >
          <div class="title-description">
            (wenn der Wert des Gutes den It. Kap. IV, Art. 23, Ab. 3 bestimmten
            Höchstbetrag<br />ubersteigt, so wird er erst nach Vereinbarung des
            Zuschlages zur Fracht angewiesen)
          </div>
        </td>
        <td
          class="cmr-content-grid-rd"
          style="
            border-bottom: 2px solid black;
            border-left: 2px solid black;
            border-top: 2px solid black;
          "
        >
          <div class="cmr-title-container">
            <!-- <div class="split-two"> -->
            <div class="title-description">Итого<br />Zu zahlende Ges.-Su.</div>
            <div></div>
            <!-- </div> -->
          </div>
        </td>
        <td
          class="cmr-content-grid-rd percents-70-border"
          style="
            border-bottom: 2px solid black;
            border-left: 2px solid black;
            border-top: 2px solid black;
          "
        >
          <div class="cmr-title-container">
            <!-- <div class="split-two"> -->
            <div class="flex-70"></div>
            <div class="flex-30"></div>
            <!-- </div> -->
          </div>
        </td>
        <td
          class="cmr-content-grid-rd magic-div-container percents-50-border"
          style="
            border-bottom: 2px solid black;
            border-left: 2px solid black;
            border-top: 2px solid black;
          "
        >
          <div class="cmr-title-container">
            <div class="flex-50"></div>
            <div class="flex-50"></div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd percents-70-border"
          style="
            border-bottom: 2px solid black;
            border-left: 2px solid black;
            border-top: 2px solid black;
          "
        >
          <div class="cmr-title-container">
            <!-- <div class="split-two"> -->
            <div class="flex-70"></div>
            <div class="flex-30"></div>
            <!-- </div> -->
          </div>
        </td>
      </tr>
      <tr class="cmr-title">
        <td
          class="cmr-content-grid-rd"
          colspan="7"
          style="border-top: 2px solid black"
        >
          <div class="cmr-title-container">
            <div class="count-indicator">14</div>
            <div class="title-description">Возврат<br />Rückerstattung</div>
          </div>
        </td>
      </tr>
      <tr class="cmr-title">
        <td
          class="cmr-content-grid-rd"
          colspan="3"
          style="border-top: 2px solid black"
        >
          <div class="cmr-title-container">
            <div class="count-indicator">15</div>
            <div class="title-description">
              Условия оплаты<br />Frachtzahlungsanweisungen &nbsp;&nbsp;<strong
                ><b
                  >{{ check_undefined(delivery_term_code) }},
                  {{ check_undefined(delivery_place_1) }}</b
                ></strong
              >
            </div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd"
          colspan="4"
          style="border-left: 2px solid black; border-top: 2px solid black"
        >
          <div class="cmr-title-container">
            <div class="count-indicator">20</div>
            <div class="title-description">
              Особые согласованные условия<br />Besondere Vereinbarungen
            </div>
          </div>
        </td>
      </tr>
      <tr class="cmr-title">
        <td class="cmr-content-grid-rd" colspan="3">
          <div class="cmr-title-container">
            <div class="title-description">франко / Frei</div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd"
          colspan="4"
          style="border-left: 2px solid black"
        >
          <div class="cmr-title-container">
            <div class="title-description"></div>
          </div>
        </td>
      </tr>
      <tr class="cmr-title">
        <td class="cmr-content-grid-rd" colspan="3">
          <div class="cmr-title-container">
            <div class="title-description">нефранко / Unfrei</div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd"
          colspan="4"
          style="border-left: 2px solid black"
        >
          <div class="cmr-title-container">
            <div class="title-description"></div>
          </div>
        </td>
      </tr>
      <tr class="cmr-title">
        <td
          class="cmr-content-grid-rd"
          colspan="2"
          style="border-bottom: 0; border-top: 2px solid black"
        >
          <div class="cmr-title-container">
            <div class="count-indicator">21</div>
            <div class="title-description">
              Составлена в<br />Ausgefertigt in
            </div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd"
          colspan="2"
          style="border-bottom: 0; border-top: 2px solid black"
        >
          <div class="cmr-title-container">
            <div class="title-description">
              Дата / am<br />
              <strong
                ><b>{{ check_undefined(TakingCargoDate) }}</b></strong
              >
            </div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd"
          colspan="2"
          style="
            border-bottom: 0;
            border-left: 2px solid black;
            border-top: 2px solid black;
          "
        >
          <div class="cmr-title-container">
            <div class="count-indicator">24</div>
            <div class="title-description">
              Груз получен<br />Gut empafangen
            </div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd"
          style="border-bottom: 0; border-top: 2px solid black"
        >
          <div class="cmr-title-container">
            <div class="title-description">Дата<br />Datum</div>
          </div>
        </td>
      </tr>
      <tr class="cmr-title">
        <td
          class="cmr-content-grid-rd"
          colspan="2"
          style="border-bottom: 0; border-top: 2px solid black"
        >
          <div class="cmr-title-container">
            <div class="count-indicator">22</div>
            <div class="title-description">
              <!-- Составлена в<br>Ausgefertigt in -->
            </div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd"
          colspan="2"
          style="
            border-bottom: 0;
            border-top: 2px solid black;
            border-left: 2px solid black;
          "
        >
          <div class="cmr-title-container">
            <div class="title-description">
              <div class="count-indicator">23</div>
              <!-- Дата<br>am -->
            </div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd"
          colspan="2"
          style="border-bottom: 0; border-left: 2px solid black"
        >
          <div class="cmr-title-container">
            <!-- <div class="count-indicator">24</div> -->
            <!-- <div class="title-description"> -->
            <!-- Груз получен<br>Gut empafangen -->
            <!-- </div> -->
          </div>
        </td>
        <td class="cmr-content-grid-rd" style="border-bottom: 0">
          <div class="cmr-title-container">
            <div class="title-description">am "________" ____________ 20</div>
          </div>
        </td>
      </tr>
      <tr class="cmr-title">
        <td
          class="cmr-content-grid-rd"
          style="border-bottom: 0; border-top: 0px solid black"
        >
          <div class="cmr-title-container">
            <!-- <div class="count-indicator">22</div> -->
            <div class="title-description">
              Прибытие под погрузку<br />Ankunft für Einladung
            </div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd"
          style="border-bottom: 0; border-top: 0px solid black"
        >
          <div class="cmr-title-container">
            <!-- <div class="count-indicator">22</div> -->
            <div class="title-description">______ час./Uhr ____ мин./Min</div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd"
          colspan="2"
          style="
            border-bottom: 0;
            border-top: 0px solid black;
            border-left: 2px solid black;
          "
        >
          <div class="cmr-title-container">
            <div class="title-description">
              <!-- <div class="count-indicator">23</div> -->
              <!-- Дата<br>am -->
              <div class="title-description">Путевой лист № ______ 20</div>
            </div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd"
          colspan="2"
          style="border-left: 2px solid black; border-bottom: 0; border-top: 0"
        >
          <div class="cmr-title-container">
            <!-- <div class="count-indicator">24</div> -->
            <div class="title-description">
              Прибытие под разгрузку<br />Ankunft für Ausladung
            </div>
          </div>
        </td>
        <td class="cmr-content-grid-rd" style="border-top: 0; border-bottom: 0">
          <div class="cmr-title-container">
            <div class="title-description">______ час./Uhr ____ мин./Min</div>
          </div>
        </td>
      </tr>
      <tr class="cmr-title">
        <td
          class="cmr-content-grid-rd"
          style="border-bottom: 0; border-top: 0px solid black"
        >
          <div class="cmr-title-container">
            <!-- <div class="count-indicator">22</div> -->
            <div class="title-description">Убытие<br />Abfahrt</div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd"
          style="border-bottom: 0; border-top: 0px solid black"
        >
          <div class="cmr-title-container">
            <!-- <div class="count-indicator">22</div> -->
            <div class="title-description">______ час./Uhr ____ мин./Min</div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd"
          colspan="2"
          style="
            border-bottom: 0;
            border-top: 0px solid black;
            border-left: 2px solid black;
          "
        >
          <div class="cmr-title-container">
            <div class="title-description">
              <!-- <div class="count-indicator">23</div> -->
              <!-- Дата<br>am -->
              <div class="title-description">Фамилии водителей</div>
            </div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd"
          colspan="2"
          style="border-left: 2px solid black; border-bottom: 0; border-top: 0"
        >
          <div class="cmr-title-container">
            <!-- <div class="count-indicator">24</div> -->
            <div class="title-description">Убытие<br />Abfahrt</div>
          </div>
        </td>
        <td class="cmr-content-grid-rd" style="border-top: 0; border-bottom: 0">
          <div class="cmr-title-container">
            <div class="title-description">______ час./Uhr ____ мин./Min</div>
          </div>
        </td>
      </tr>
      <tr class="cmr-title">
        <td
          class="cmr-content-grid-rd"
          colspan="2"
          style="border-bottom: 2px solid black; border-top: 0px solid black"
        >
          <div class="cmr-title-container">
            <!-- <div class="count-indicator">22</div> -->
            <div class="title-description">
              Подпись и штамп отправителя<br />Unterschrift und Stempel des
              Absenders
            </div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd"
          colspan="2"
          style="
            border-bottom: 2px solid black;
            border-top: 0px solid black;
            border-left: 2px solid black;
          "
        >
          <div class="cmr-title-container">
            <div class="title-description">
              <!-- <div class="count-indicator">23</div> -->
              <!-- Дата<br>am -->
              <div class="title-description">
                Подпись и штамп отправителя<br />Unterschrift und Stempel des
                Absenders
              </div>
            </div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd"
          colspan="3"
          style="
            border-left: 2px solid black;
            border-bottom: 2px solid black;
            border-top: 0;
          "
        >
          <div class="cmr-title-container">
            <!-- <div class="count-indicator">24</div> -->
            <div class="title-description">
              Подпись и штамп отправителя<br />Unterschrift und Stempel des
              Absenders
            </div>
          </div>
        </td>
      </tr>
      <tr class="cmr-title">
        <td
          class="cmr-content-grid-rd"
          style="border-right: 2px solid black; border-top: 0px solid black"
        >
          <div class="cmr-title-container">
            <div class="count-indicator">25</div>
            <div class="title-description">
              <div style="display: flex">
                <div style="flex-basis: 50%">
                  Регистрац. номер/Amtl.<br />Тягач/Kfz
                </div>
                <div style="flex-basis: 50%">
                  Kennzeichen<br />Полуприцеп/Anhänger
                </div>
              </div>
            </div>
          </div>
        </td>
        <td class="cmr-content-grid-rd" style="border-top: 0px solid black">
          <div class="cmr-title-container">
            <div class="count-indicator">26</div>
            <div class="title-description">
              <div style="display: flex">
                <div style="flex-basis: 50%"><br />Тягач/Kfz</div>
                <div style="flex-basis: 50%">
                  Марка/Typ<br />Полуприцеп/Anhänger
                </div>
              </div>
            </div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd"
          colspan="5"
          style="border-left: 2px solid black; border-top: 0"
        >
          <div class="cmr-title-container" style="width: 100%">
            <div class="count-indicator">27</div>
            <div class="title-description" style="flex-basis: 100%">
              <div class="le-grid">
                <div>Тариф I за 1 км</div>
                <div>Тарифное расстояние</div>
                <div>% за испол. тягача/п/пр.</div>
                <div>Поясной коэфф.</div>
                <div>Прочие доплаты</div>
                <div>Сумма</div>
              </div>
            </div>
          </div>
        </td>
      </tr>
      <tr class="cmr-title">
        <td
          class="cmr-content-grid-rd"
          style="border-right: 2px solid black; border-top: 0px solid black"
        >
          <div class="cmr-title-container">
            <b>{{ check_undefined(CMR.cmr_track) }}</b> /
            <b>{{ check_undefined(CMR.cmr_trailer) }}</b>
          </div>
        </td>
        <td class="cmr-content-grid-rd" style="border-top: 0px solid black">
          <div class="cmr-title-container"></div>
        </td>
        <!-- <td class="cmr-content-grid-rd" colspan=5 rowspan=4  style="border-left: 2px solid black; border-top: 0;">
            <div class="cmr-title-container" style="width: 100%;">
                <div class="title-description" style="flex-basis: 100%;">
                    
                </div>
            </div>
        </td> -->
      </tr>
      <!-- <tr class="cmr-title">
        <td class="cmr-content-grid-rd" style="border-right: 2px solid black;border-top: 0px solid black;">
            <div class="cmr-title-container">
                
            </div>
        </td>
        <td class="cmr-content-grid-rd" style="border-top: 0px solid black;border-right: 0">
            <div class="cmr-title-container">
                
            </div>
        </td>
        
    </tr>
    <tr class="cmr-title">
        <td class="cmr-content-grid-rd" style="border-right: 2px solid black;border-top: 0px solid black;">
            <div class="cmr-title-container">
                
            </div>
        </td>
        <td class="cmr-content-grid-rd" style="border-top: 0px solid black;border-right: 0">
            <div class="cmr-title-container">
                
            </div>
        </td>
        
    </tr>
    <tr class="cmr-title">
        <td class="cmr-content-grid-rd" style="border-right: 2px solid black;border-top: 0px solid black;">
            <div class="cmr-title-container">
                
            </div>
        </td>
        <td class="cmr-content-grid-rd" style="border-top: 0px solid black;border-right: 0">
            <div class="cmr-title-container">
                
            </div>
        </td>
    </tr> -->
      <tr class="cmr-title">
        <td
          class="cmr-content-grid-rd"
          colspan="5"
          style="
            border-right: 2px solid black;
            border-top: 2px solid black;
            border-bottom: 0;
          "
        >
          <div class="cmr-title-container" style="width: 100%">
            <div class="count-indicator">28</div>
            <div class="title-description" style="flex-basis: 100%">
              <div class="le-grid bordered">
                <div>Тариф. расст., км</div>
                <div>Схема</div>
                <div style="color: white">Схема</div>
                <div>Тариф за 1 т</div>
                <div>Надбавки</div>
                <div>Скидки</div>
                <div>Прочие доплаты</div>
                <div>К оплате</div>
              </div>
            </div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd"
          colspan="2"
          style="border-top: 2px solid black; border-bottom: 0"
        >
          <div class="cmr-title-container">
            <!-- <div class="count-indicator">26</div> -->
            <div class="title-description">
              <!-- <div style="display: flex; "> -->
              <!-- <div style="flex-basis: 50%;"><br>Тягач/Kfz</div> -->
              Отчисления
              <!-- </div> -->
            </div>
          </div>
        </td>
      </tr>
      <tr class="cmr-title">
        <td
          class="cmr-content-grid-rd"
          colspan="5"
          style="
            border-right: 2px solid black;
            border-top: 0px solid black;
            border-bottom: 0;
          "
        >
          <div class="cmr-title-container" style="width: 100%">
            <!-- <div class="count-indicator">28</div> -->
            <div class="title-description" style="flex-basis: 100%">
              Тариф II
            </div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd"
          colspan="2"
          style="border-top: 1px solid black; border-bottom: 0"
        >
          <div class="cmr-title-container">
            <!-- <div class="count-indicator">26</div> -->
            <div class="title-description">
              <!-- <div style="display: flex; "> -->
              <!-- <div style="flex-basis: 50%;"><br>Тягач/Kfz</div> -->
              Оплачено заказчиком
              <!-- </div> -->
            </div>
          </div>
        </td>
      </tr>
      <tr class="cmr-title">
        <td
          class="cmr-content-grid-rd"
          colspan="5"
          style="
            border-right: 2px solid black;
            border-top: 0px solid black;
            border-bottom: 2px solid black;
          "
        >
          <div class="cmr-title-container" style="width: 100%">
            <div class="count-indicator" style="color: #fff">28</div>
            <div class="title-description" style="flex-basis: 100%">
              <!-- Тариф II -->
              <div class="le-grid bordered bordered-bottom">
                <div>Тариф. расстояние,км</div>
                <div>Схема</div>
                <div style="color: white">Схема</div>
                <div>Тариф за 1 т</div>
                <div>Надбавки</div>
                <div>Скидки</div>
                <div>Прочие доплаты</div>
                <div style="border-left-width: 2px">К оплате</div>
              </div>
            </div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd"
          colspan="2"
          style="border-top: 1px solid black; border-bottom: 2px solid black"
        >
          <div class="cmr-title-container">
            <!-- <div class="count-indicator">26</div> -->
            <div class="title-description">
              <!-- <div style="display: flex; "> -->
              <!-- <div style="flex-basis: 50%;"><br>Тягач/Kfz</div> -->
              К оплате
              <!-- </div> -->
            </div>
          </div>
        </td>
      </tr>
      <tr class="cmr-title">
        <td
          class="cmr-content-grid-rd"
          colspan="5"
          style="
            border-right: 0px solid black;
            border-top: 0px solid black;
            border-bottom: 0;
          "
        >
          <div class="cmr-title-container" style="width: 100%">
            <div class="count-indicator">29</div>
            <div class="title-description" style="flex-basis: 100%">
              <div class="le-grid bordered" style="color: white">
                <div style="border-bottom: 0">Тариф. расст., км</div>
                <div style="border-bottom: 0">Схема</div>
                <div style="border-bottom: 0; color: white">Схема</div>
                <div style="border-bottom: 0">Тариф за 1 т</div>
                <div style="border-bottom: 0">Надбавки</div>
                <div style="border-bottom: 0">Скидки</div>
                <div style="border-bottom: 0">Прочие доплаты</div>
                <div style="border-bottom: 0">К оплате</div>
              </div>
            </div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd"
          colspan="1"
          style="
            border-left: 1px solid black;
            border-top: 0px solid black;
            border-bottom: 1px solid black;
          "
        >
          <div class="cmr-title-container">
            <!-- <div class="count-indicator">26</div> -->
            <div class="title-description">
              <!-- <div style="display: flex; "> -->
              <!-- <div style="flex-basis: 50%;"><br>Тягач/Kfz</div> -->
              Валюта
              <!-- </div> -->
            </div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd"
          colspan="1"
          style="
            border-left: 1px solid black;
            border-top: 0px solid black;
            border-bottom: 1px solid black;
          "
        >
          <div class="cmr-title-container">
            <!-- <div class="count-indicator">26</div> -->
            <div class="title-description">
              <!-- <div style="display: flex; "> -->
              <!-- <div style="flex-basis: 50%;"><br>Тягач/Kfz</div> -->
              Код плательщика
              <!-- </div> -->
            </div>
          </div>
        </td>
      </tr>
      <tr class="cmr-title">
        <td
          class="cmr-content-grid-rd"
          colspan="5"
          style="
            border-right: 0px solid black;
            border-top: 0px solid black;
            border-bottom: 0;
          "
        >
          <div class="cmr-title-container" style="width: 100%">
            <!-- <div class="count-indicator">28</div> -->
            <div class="title-description" style="flex-basis: 100%">
              Тариф III
            </div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd"
          colspan="2"
          style="border-top: 0px solid black; border-bottom: 0"
        >
          <div class="cmr-title-container">
            <!-- <div class="count-indicator">26</div> -->
            <div class="title-description">
              <!-- <div style="display: flex; "> -->
              <!-- <div style="flex-basis: 50%;"><br>Тягач/Kfz</div> -->

              <!-- </div> -->
            </div>
          </div>
        </td>
      </tr>
      <tr class="cmr-title">
        <td
          class="cmr-content-grid-rd"
          colspan="5"
          style="
            border-right: 2px solid black;
            border-top: 0px solid black;
            border-bottom: 2px solid black;
          "
        >
          <div class="cmr-title-container" style="width: 100%">
            <div class="count-indicator" style="color: #fff">29</div>
            <div class="title-description" style="flex-basis: 100%">
              <!-- Тариф II -->
              <div class="le-grid bordered bordered-bottom">
                <div>Тариф. расстояние,км</div>
                <div>Схема</div>
                <div style="color: white">Схема</div>
                <div>Тариф за 1 т</div>
                <div>Надбавки</div>
                <div>Скидки</div>
                <div>Прочие доплаты</div>
                <div style="border-left-width: 2px">К оплате</div>
              </div>
            </div>
          </div>
        </td>
        <td
          class="cmr-content-grid-rd"
          colspan="2"
          style="border-top: 0px solid black; border-bottom: 2px solid black"
        >
          <div class="cmr-title-container">
            <!-- <div class="count-indicator">26</div> -->
            <div class="title-description">
              <!-- <div style="display: flex; "> -->
              <!-- <div style="flex-basis: 50%;"><br>Тягач/Kfz</div> -->
              <!-- К оплате -->
              <!-- </div> -->
            </div>
          </div>
        </td>
      </tr>
    </table>
    <div class="cmr-logo-main">
      <div>CMR</div>
    </div>
    <canvas id="signature_canvas" style="margin-top: 50px"></canvas>
  </div>
</template>
<script>
import moment from "moment";
var QRCode = require("qrcode");
export default {
  props: ["user_id", "doc_id"],
  data() {
    return {
      cmr_custom_code: "",
      cmr_courier_notes: "",
      contract_payment_type: "",
      оrganizations: {},
      xml: "",
      ecp_storage: "",
      document_number: "-",
      invoice: {},
      currencies: [],
      CMR: {
        cmr_sender: {
          display_text: "",
        },
        cmr_recipient: {
          display_text: "",
        },
        cmr_courier: {
          display_text: "",
        },
        cmr_courier_next: {
          display_text: "",
        },
      },
      CMRGoods: [],
      EnclosedDocument: {},
      ContractDeliveryTerms: {},
      TakingCargoPlace: {
        CountryCode: {
          display_text: "",
        },
      },
      TakingCargoDate: "",
      ConsigneeCustoms: {},
      CMR_docs: [],
      country: "",

      sender: {},
      recipient: {},

      delivery_place_1: "",
      delivery_term_code: "",
      city: "",
      street_house: "",
      postal_code: "",
      taking_country: "",
      courier: {},
      courier_next: {},
    };
  },
  mounted() {
    axios
      .get(window.base + "/Document/LoadCMR/?doc_id=" + this.doc_id)
      .then((response) => {
        //load country
        if (typeof response.data.CountryCode !== "undefined") {
          axios
            .get(
              window.base +
                "/library/country?code=" +
                response.data.CountryCode.trim() +
                "&lang=" +
                this.$i18n.locale,
            )
            .then((l) => {
              if (
                typeof l.data[0] !== "undefined" &&
                typeof l.data[0].display_text !== "undefined"
              )
                this.country = l.data[0].display_text;
            });
        }

        //loading_documents
        // axios.get(window.base + '/document?attis_contract_id='+this.$route.params.id).
        // then(response=>{
        //     response.data.forEach(item=>{
        //         if(item.DocType=='Пакинг лист'){
        //             //adding packing list document to the document lists
        //             this.CMR_docs.push(item)
        //         }
        //         if(item.DocType=='Инвойс'){
        //             //adding invoice document to the document lists
        //             this.CMR_docs.push(item)
        //         }
        //     })
        // })
        this.CMR_docs = this.check_undefined(response.data.docs);
        //load customs data
        // axios.get(window.base + '/library/customs_office?code='+response.data.custom_code).then(r=>{
        //     if(typeof r.data[0] !== 'undefined' && typeof r.data[0].display_text !== 'undefined')
        //         this.cmr_custom_code = r.data[0].display_text
        // })
        if (typeof response.data.customs_office == "object") {
          this.cmr_custom_code =
            this.check_undefined(response.data.customs_office.custom_name) +
            "<br>";
          this.cmr_custom_code +=
            this.check_undefined(response.data.customs_office.custom_addr) +
            "<br>";
          this.cmr_custom_code +=
            this.check_undefined(response.data.customs_office.custom_email) +
            "<br>";
          this.cmr_custom_code +=
            "Тел.: " +
            this.check_undefined(response.data.customs_office.custom_phone) +
            "<br>";
          this.cmr_custom_code +=
            "Факс: " +
            this.check_undefined(response.data.customs_office.custom_fax);
        }

        //load courier_notes
        this.cmr_courier_notes = this.check_undefined(
          response.data.courier_notes,
        );

        this.delivery_term_code = this.check_undefined(
          response.data.DeliveryTermsStringCode,
        );
        this.delivery_place_1 = this.check_undefined(
          response.data.DeliveryPlace,
        );
        //load contract
        // axios.get(window.base + '/Contract/GetContract?attis_contract_id='+this.$route.params.id).then(r=>{
        //     // this.contract = r.data
        //     // this.contract.attis_contract_payment_type =
        //     axios.get(window.base + '/library/payment_type?code='+r.data.attis_contract_payment_type+'&lang='+this.$i18n.locale).then(e=>{
        //         if(typeof e.data[0] !== 'undefined' && typeof e.data[0].display_text !== 'undefined')
        //             this.contract_payment_type = e.data[0].value// + e.data[0].display_text
        //     })
        // })

        // this.$emit('file', response.data.files)
        this.CMR.cmr_number = this.check_undefined(response.data.cmr_number);
        this.CMR.cmr_date = this.check_undefined(response.data.cmr_date);
        this.TakingCargoDate = this.check_undefined(
          response.data.TakingCargoDate,
        );
        this.sender = this.check_undefined(response.data.sender);
        this.recipient = this.check_undefined(response.data.recipient);

        this.courier = this.check_undefined(response.data.courier);
        this.courier_next = this.check_undefined(response.data.courier_next);

        this.city = this.check_undefined(response.data.City);
        this.street_house = this.check_undefined(response.data.StreetHouse);
        this.postal_code = this.check_undefined(response.data.PostalCode);
        // axios.get(window.base + '/document/getFirmDetails?bin='+response.data.cmr_sender).then(response_=>{
        //     this.CMR.cmr_sender = {value: response.data.cmr_sender, display_text: response_.data.org_name}
        // })
        // // this.findLibValue('company', response.data.cmr_sender , 'CMR', 'cmr_sender')
        // // this.CMR.cmr_sender = response.data.cmr_sender
        // axios.get(window.base + '/document/getFirmDetails?bin='+response.data.cmr_recipient).then(response_=>{
        //     this.CMR.cmr_recipient = {value: response.data.cmr_recipient, display_text: response_.data.org_name}
        // })
        // this.findLibValue('company', response.data.cmr_recipient , 'CMR', 'cmr_recipient')
        // this.CMR.cmr_recipient = response.data.cmr_recipient
        axios
          .get(
            window.base +
              "/document/getFirmDetails?bin=" +
              this.check_undefined(response.data.cmr_courier),
          )
          .then((response_) => {
            this.CMR.cmr_courier = {
              value: response.data.cmr_courier,
              display_text: this.check_undefined(response_.data.org_name),
            };
          });
        // this.findLibValue('company', response.data.cmr_courier , 'CMR', 'cmr_courier')
        // this.CMR.cmr_courier = response.data.cmr_courier
        axios
          .get(
            window.base +
              "/document/getFirmDetails?bin=" +
              this.check_undefined(response.data.cmr_courier_next),
          )
          .then((response_) => {
            this.CMR.cmr_courier_next = {
              value: response.data.cmr_courier_next,
              display_text: this.check_undefined(response_.data.org_name),
            };
          });
        // this.findLibValue('company', response.data.cmr_courier_next , 'CMR', 'cmr_courier_next')
        // this.CMR.cmr_courier_next = response.data.cmr_courier_next

        this.CMR.cmr_track = this.check_undefined(response.data.cmr_track);
        this.CMR.cmr_trailer = this.check_undefined(response.data.cmr_trailer);

        this.ContractDeliveryTerms.DeliveryPlace = this.check_undefined(
          response.data.DeliveryPlace,
        );
        this.findDeliveryTerm(
          this.check_undefined(response.data.DeliveryTermsStringCode),
        );
        // this.findLibValue('delivery_term', response.data.DeliveryTermsStringCode , 'ContractDeliveryTerms', 'DeliveryTermsStringCode')
        // this.ContractDeliveryTerms.DeliveryTermsStringCode=response.data.DeliveryTermsStringCode
        this.ContractDeliveryTerms.TermsDescription = this.check_undefined(
          response.data.TermsDescription,
        );

        // axios.get(window.base + '/library/country?code='+response.data.CountryCode).then(cr=>{
        //     if(typeof cr.data[0] !== 'undefined')
        //         this.taking_country = cr.data[0].display_text
        // })

        // this.findLibValue('country', response.data.CountryCode, 'TakingCargoPlace', 'CountryCode')
        // this.TakingCargoPlace.CountryCode=response.data.CountryCode
        this.TakingCargoPlace.City = this.check_undefined(response.data.City);
        this.TakingCargoPlace.StreetHouse = this.check_undefined(
          response.data.StreetHouse,
        ).trim();
        this.TakingCargoPlace.PostalCode = this.check_undefined(
          response.data.PostalCode,
        ).trim();
        this.TakingCargoPlace.TakingCargoDate = this.check_undefined(
          response.data.TakingCargoDate,
        );

        this.EnclosedDocument.PrDocumentName = this.check_undefined(
          response.data.PrDocumentName,
        );
        this.EnclosedDocument.PrDocumentNumber = this.check_undefined(
          response.data.PrDocumentNumber,
        );
        this.EnclosedDocument.PrDocumentDate = this.check_undefined(
          response.data.PrDocumentDate,
        );

        this.ConsigneeCustoms.WarehouseName = this.check_undefined(
          response.data.WarehouseName,
        );

        response.data.product.forEach((good, index) => {
          var tmp_good = {
            GoodMarking: this.check_undefined(good.GoodMarking),
            GoodsDescription: this.check_undefined(good.GoodsDescription),
            GoodsQuantity: this.check_undefined(good.GoodsQuantity),
            GrossWeightQuantity: this.check_undefined(good.GrossWeightQuantity),
            GoodsNomenclatureCode: this.check_undefined(
              good.GoodsNomenclatureCode,
            ),
            VolumeQuantity: this.check_undefined(good.VolumeQuantity),
            places: this.check_undefined(good.places),
          };
          this.CMRGoods.push(tmp_good);
        });
        // this.$root.$emit('print-pdf', '')
        axios
          .get(window.base + "/document/LoadSignature?doc_id=" + this.doc_id)
          .then((response) => {
            if (typeof response.data.signature !== "undefined") {
              // console.log("as")
              if (response.data.signature == "") {
                setTimeout(() => {
                  this.$root.$emit("print-pdf", { signature: "", type: "cmr" });
                }, 1000);

                new Noty({
                  theme: "light",
                  type: "error",
                  text: this.$t("message.contracts.no-signature-message"),
                  timeout: 5000,
                }).show();
              } else {
                var canvas = QRCode.toCanvas(response.data.signature, {
                  width: 100,
                  height: 100,
                });
                canvas.then((r) => {
                  // this.check_signature(value, ()=>{
                  setTimeout(() => {
                    this.$root.$emit("print-pdf", {
                      signature: "",
                      type: "cmr",
                    });
                  }, 1000);
                  new Noty({
                    theme: "light",
                    type: "success",
                    text: this.$t("message.contracts.yes-signature-message"),
                    timeout: 5000,
                  }).show();
                  // window.webSocket.removeEventListener('message', {})
                  // })
                });
              }
            } else {
              // console.log("bs")
              this.$root.$emit("print-pdf", { signature: "", type: "cmr" });
              new Noty({
                theme: "light",
                type: "error",
                text: this.$t("message.contracts.no-signature-message"),
                timeout: 5000,
              }).show();
            }
          });
        /*axios.get(window.base + '/document/LoadCMRXML?doc_id='+this.doc_id).then(response=>{
                this.xml = response.data.replace('<?xml version="1.0" encoding="utf-16"?>', '')
                window.webSocket = new WebSocket('wss://127.0.0.1:13579/');
                window.callback = null;

                window.webSocket.onopen = (event)=>{
                    console.log("Connection opened");
                    // window.getKeyInfo("PKCS12", (r)=>{
                    //     console.log('info', r)
                    // })
                    window.signXml("PKCS12", "SIGNATURE", this.xml, (tmp)=>{
                        // console.log(tmp)
                    });
                };

                window.webSocket.onclose = function (event) {
                    if (event.wasClean) {
                        console.log('connection has been closed');
                    } else {
                        console.log('Connection error');
                        openDialog();
                    }
                    console.log('Code: ' + event.code + ' Reason: ' + event.reason);
                };

                window.webSocket.onmessage = (event) => {
                    var result = JSON.parse(event.data);
                    console.log(result, event)
                    if (result != null) {
                        var rw = {
                            code: result['code'],
                            message: result['message'],
                            responseObject: result['responseObject'],
                            getResult: function () {
                                return this.result;
                            },
                            getMessage: function () {
                                return this.message;
                            },
                            getResponseObject: function () {
                                return this.responseObject;
                            },
                            getCode: function () {
                                return this.code;
                            }
                        };
                        this.callback(rw)
                    }
                };
            })*/
      });

    // axios.get(window.base+'/library?type=currency&query=&qty=10000').then(response=>{
    //     this.currencies = response.data
    //     axios.get(window.base + '/document/LoadInvoice?doc_id='+this.doc_id).then(response=>{
    //         this.invoice = response.data
    //         axios.get(window.base+'/document/getFirmbyBin?bin='+this.invoice.InvoiceByer).then(response=>{
    //             this.buyer = response.data
    //             axios.get(window.base+'/document/getFirmbyBin?bin='+this.invoice.InvoiceSeller).then(response=>{
    //                 this.seller = response.data
    //                 axios.get(window.base + '/contract/pdfNumber').then(response=>{
    //                     this.document_number = response.data
    //                     axios.get(window.base + '/document/LoadInvoiceXML?doc_id='+this.doc_id).then(response=>{
    //                         this.xml = response.data.replace('<?xml version="1.0" encoding="utf-16"?>', '')
    //                         window.webSocket = new WebSocket('wss://127.0.0.1:13579/');
    //                         window.callback = null;

    //                         window.webSocket.onopen = (event)=>{
    //                             console.log("Connection opened");
    //                             // window.getKeyInfo("PKCS12", (r)=>{
    //                             //     console.log('info', r)
    //                             // })
    //                             window.signXml("PKCS12", "SIGNATURE", this.xml, (tmp)=>{
    //                                 // console.log(tmp)
    //                             });
    //                         };

    //                         window.webSocket.onclose = function (event) {
    //                             if (event.wasClean) {
    //                                 console.log('connection has been closed');
    //                             } else {
    //                                 console.log('Connection error');
    //                                 openDialog();
    //                             }
    //                             console.log('Code: ' + event.code + ' Reason: ' + event.reason);
    //                         };

    //                         window.webSocket.onmessage = (event) => {
    //                             var result = JSON.parse(event.data);
    //                             console.log(result, event)
    //                             if (result != null) {
    //                                 var rw = {
    //                                     code: result['code'],
    //                                     message: result['message'],
    //                                     responseObject: result['responseObject'],
    //                                     getResult: function () {
    //                                         return this.result;
    //                                     },
    //                                     getMessage: function () {
    //                                         return this.message;
    //                                     },
    //                                     getResponseObject: function () {
    //                                         return this.responseObject;
    //                                     },
    //                                     getCode: function () {
    //                                         return this.code;
    //                                     }
    //                                 };
    //                                 this.callback(rw)
    //                             }
    //                         };
    //                     })
    //                 })
    //             })
    //         })

    //     })
    // })
  },
  methods: {
    findDeliveryTerm(code) {
      axios
        .get(
          window.base +
            "/library/delivery_term?code=" +
            code +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          if (typeof response.data[0] !== "undefined")
            this.$set(
              this.ContractDeliveryTerms,
              "DeliveryTermsStringCode",
              response.data[0],
            );
          // this.$set(this.attis_contract_goods[index], 'attis_cg_TNVED', response.data[0])
        });
    },
    findLibValue(lib, value, object, field) {
      if (typeof lib == "string") {
        axios
          .get(
            window.base +
              "/library?type=" +
              lib +
              "&query=&qty=1000" +
              "&lang=" +
              this.$i18n.locale,
          )
          .then((response) => {
            response.data.forEach((item) => {
              if (
                item.value.trim().toLowerCase() == value.trim().toLowerCase()
              ) {
                this.$set(this.$data[object], field, item);
              }
            });
          });
      } else {
        lib.forEach((item) => {
          if (item.value.trim().toLowerCase() == value.trim().toLowerCase())
            this.$set(this.$data[object], field, item);
        });
      }
    },
    /**
     * Checks if newly generated signature is similar to the one previously saved on the server.
     * If got true – everything ok, can download file, if false – then the document
     * has not been signed yet or has been changed after signing.
     */
    check_signature(signature, callback) {
      var fd = new FormData();
      fd.append("contract_id", this.doc_id);
      fd.append("signature", signature);
      axios.post(window.base + "/document/CheckSignature", fd).then((r) => {
        if (r.data == "False") {
          new Noty({
            theme: "light",
            type: "error",
            text: this.$root.$t("message.message.document_signature_is_wrong"),
            timeout: 5000,
          }).show();
        } else {
          new Noty({
            theme: "light",
            type: "success",
            text: this.$root.$t("message.message.document_signature_is_ok"),
            timeout: 5000,
          }).show();
          callback();
        }
      });
    },
    callback(r) {
      console.log(r);
      if (r.code == "200") {
        // console.log(r)
        var oParser = new DOMParser();
        var oDOM = oParser.parseFromString(
          r.getResponseObject(),
          "application/xml",
        );
        var value = oDOM.getElementsByTagName("ds:SignatureValue")[0].innerHTML;
        var canvas = QRCode.toCanvas(value, { width: 100, height: 100 });
        canvas.then((r) => {
          this.check_signature(value, () => {
            this.$root.$emit("print-pdf", { signature: r, type: "cmr" });
            window.webSocket.close();
          });
        });
      }
    },
    check_undefined(field) {
      if (typeof field !== "undefined" && field !== "null") return field;
      return "";
    },
  },
  computed: {
    weight_total() {
      var sum = 0;
      this.CMRGoods.forEach((good) => {
        sum += good.GrossWeightQuantity;
      });
      return sum;
    },
    volume_total() {
      var sum = 0;
      this.CMRGoods.forEach((good) => {
        sum += good.VolumeQuantity;
      });
      return sum;
    },
    date() {
      return moment().format("D.MM.Y");
    },
    currency() {
      var c = "";
      if (typeof this.invoice.CurrencyCode !== "undefined")
        this.currencies.forEach((item) => {
          if (item.value == this.invoice.CurrencyCode.trim()) {
            c = item.display_text;
          }
        });
      return c;
    },
  },
};
</script>
<style scoped>
.cmr-logo-main {
  font-family: sans-serif;
  opacity: 0.2;
  z-index: 0;
  left: 0;
  right: 0;
  text-align: center;
  top: 120mm;
  position: absolute;
}
.cmr-logo-main div {
  border: 20px solid black;
  border-radius: 50%;
  padding: 30px;
  font-size: 200px;
  display: inline;
}
.cmr-content-grid td,
.cmr-content-grid-rd {
  padding: 5px 10px;
  font-family: sans-serif;
}
.cmr-content-grid-rd:first-of-type {
  border-left: 2px solid black;
}
.cmr-content-grid-rd:last-of-type {
  border-right: 2px solid black;
}
.cmr-title td .cmr-title-container {
  display: flex;
  align-items: center;
}
.cmr-title td {
  border-bottom: 1px solid black;
  padding: 0 5px;
}
.cmr-title td .count-indicator {
  font-size: 18px;
  font-weight: bold;
}
.cmr-title td .title-description {
  font-size: 10px;
  line-height: 13px;
  margin: 2px 5px;
}
.cmr-content td {
  font-size: 12px;
  border-bottom: 1px solid black;
  padding: 0 5px;
}
.cmr-content td:last-of-type {
  border-bottom: 2px solid black;
}
.cmr-content td div {
  padding: 5px 10px;
  border-bottom: 1px solid #000;
  margin-left: -4px;
  margin-right: -5px;
}
.cmr-content td div:last-of-type {
  border-bottom: 0;
}
.cmr-content td div.split-two,
.cmr-content td div.split-two div {
  display: flex;
  padding: 0;
  margin: 0;
  border: 0;
}
.cmr-content td div.split-two div {
  flex-basis: 50%;
  padding: 10px;
}
.cmr-content td div.split-two div .logo {
  border: 2px solid black;
  border-radius: 50%;
  display: inline !important;
  flex-basis: auto;
  font-size: 48px;
  align-self: flex-start;
  font-weight: bold;
  padding: 10px;
}
.flex-70 {
  flex-basis: 70%;
}
.flex-30 {
  flex-basis: 30%;
}
.flex-50 {
  flex-basis: 50%;
}
.percents-50-border {
  position: relative;
}
.percents-50-border:after {
  content: "";
  border-right: 2px solid black;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 46%;
}
.percents-50-border > div > div:last-child {
  padding-left: 10px;
}
.percents-70-border {
  position: relative;
}
.percents-70-border:after {
  content: "";
  border-right: 1px solid black;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 65%;
}
.percents-70-border > div > div:last-child {
  padding-left: 10px;
}
.le-grid {
  display: flex;
  width: 100%;
  flex-wrap: nowrap;
  justify-content: space-around;
}
.le-grid.bordered {
  align-items: flex-start;
  margin-top: -3px;
  line-height: 30px;
  justify-content: flex-end;
  margin-left: 4px;
}
.le-grid.bordered div {
  border-left: 1px solid black;
  padding: 5px 10px;

  flex-basis: 100%;
  border-bottom: 1px solid black;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* max-width: 10.5%;
        flex-basis: 10.5%;
        min-width: 10.5%; */
}
.le-grid.bordered.bordered-bottom {
  align-items: flex-end;
  margin-top: 0;
  /* justify-content: flex-end; */
  margin-bottom: -3px;
  color: #fff;
}
table {
  font-size: 12px;
}
b {
  font-weight: bold;
  line-height: 12px;
}
</style>
